"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Carousel = function Carousel(_ref) {
    var itemName = _ref.itemName,
        mediaArray = _ref.mediaArray;
    return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
            "div",
            { id: "itemCarousel", className: "carousel slide", "data-ride": "carousel", "data-interval": "false" },
            _react2.default.createElement(
                "ol",
                { className: "carousel-indicators hide-indicators" },
                mediaArray.map(function (media, index, array) {
                    var classNameMedia = index == 0 ? "active" : "";
                    return _react2.default.createElement("li", {
                        "data-target": "#itemCarousel",
                        "data-slide-to": index,
                        className: classNameMedia,
                        key: 'cara' + index
                    });
                })
            ),
            _react2.default.createElement(
                "div",
                { className: "carousel-inner", role: "listbox" },
                mediaArray.map(function (media, index, array) {
                    var classNameMedia = index === 0 ? "item active" : "item";

                    return _react2.default.createElement(
                        "div",
                        { className: classNameMedia, key: "ccm" + index },
                        _react2.default.createElement("img", {
                            src: media.url,
                            className: "img-responsive center-block",
                            alt: itemName
                        })
                    );
                })
            ),
            _react2.default.createElement(
                "a",
                { className: "left carousel-control", href: "#itemCarousel", role: "button", "data-slide": "prev" },
                _react2.default.createElement("span", { className: "glyphicon glyphicon-chevron-left", "aria-hidden": "true" }),
                _react2.default.createElement(
                    "span",
                    { className: "sr-only" },
                    "Previous"
                )
            ),
            _react2.default.createElement(
                "a",
                { className: "right carousel-control", href: "#itemCarousel", role: "button", "data-slide": "next" },
                _react2.default.createElement("span", { className: "glyphicon glyphicon-chevron-right", "aria-hidden": "true" }),
                _react2.default.createElement(
                    "span",
                    { className: "sr-only" },
                    "Next"
                )
            )
        )
    );
};

exports.default = Carousel;


//////////////////
// WEBPACK FOOTER
// ./src/components/generic/image-handling/carousel.jsx
// module id = 477
// module chunks = 0